export var DiscordCommand = /*#__PURE__*/ function(DiscordCommand) {
    DiscordCommand["ContentFrameReady"] = "content-frame-ready";
    DiscordCommand["Subscribe"] = "subscribe";
    DiscordCommand["Unsubscribe"] = "unsubscribe";
    DiscordCommand["SetActivity"] = "set-activity";
    DiscordCommand["DispatchDiscordEvent"] = "dispatch";
    DiscordCommand["OpenExternalLink"] = "open-external-link";
    DiscordCommand["InviteFriends"] = "invite-friends";
    DiscordCommand["Purchase"] = "purchase";
    DiscordCommand["ShareMoment"] = "share-moment";
    DiscordCommand["ShareActivityLink"] = "share-activity-link";
    DiscordCommand["SetOrientation"] = "set-orientation";
    return DiscordCommand;
}({});
export var DiscordCustomEvent = /*#__PURE__*/ function(DiscordCustomEvent) {
    DiscordCustomEvent["Ready"] = "ready";
    DiscordCustomEvent["CreateMountPopup"] = "create-mount-popup";
    return DiscordCustomEvent;
}({});
export var DiscordMountPopupType = /*#__PURE__*/ function(DiscordMountPopupType) {
    DiscordMountPopupType["UserAlreadyHasMembershipError"] = "user-already-has-membership-error";
    return DiscordMountPopupType;
}({});
export var SDKRequest = /*#__PURE__*/ function(SDKRequest) {
    SDKRequest[SDKRequest["PurchaseMembership"] = 0] = "PurchaseMembership";
    SDKRequest[SDKRequest["PurchaseGift"] = 1] = "PurchaseGift";
    SDKRequest[SDKRequest["PurchaseCoins"] = 2] = "PurchaseCoins";
    SDKRequest[SDKRequest["InviteFriends"] = 3] = "InviteFriends";
    SDKRequest[SDKRequest["ShareMoment"] = 4] = "ShareMoment";
    SDKRequest[SDKRequest["OpenExternalLink"] = 5] = "OpenExternalLink";
    SDKRequest[SDKRequest["ShareActivityLink"] = 6] = "ShareActivityLink";
    return SDKRequest;
}({});
